module.exports = __webpack_public_path__ + "account/img/280.29564e7e.png";